module.exports = __webpack_public_path__ + "img/arrow-up-short.22fbd6fc.svg";